/** The same comparison the server makes of the typed confirmation: case and surrounding spaces
 * do not matter, so a phone's capitalised first letter does not block closing. */
export function sameEmail(typed: string, email: string | undefined): boolean {
  return !!email && typed.trim().toLowerCase() === email.toLowerCase();
}
